export enum CourseStatus {
    Incomplete = 'Incomplete',
    Reviewed = 'Reviewed',
    Completed = 'Completed'
}